module.exports = __webpack_public_path__ + "img/profile-avatar-w.1942cf64.svg";